import * as $ from 'jquery';

export function shrinkText() {
  const $text = $('.js-shrinkText');
  $text.each((index, element) => {
    const $singleText = $(element);
    const $singleTextChild = $(element).find('.shrinkText__text');
    const $button = $singleText.find('.js-shrinkTextButton');
    $button.on('click', () => {
      $singleText.toggleClass('shrinkText--grow');
      if (!$singleTextChild.is('[style]')) {
        $singleTextChild.css('max-height', $singleTextChild.find('div').height() || '10000px');
      } else {
        $singleTextChild.removeAttr('style');
      }
    });
  });
}
